export default __webpack_public_path__ + "static/media/repayment-channel-icon10.f3ce4fe2.png";